import { c as _c } from "react/compiler-runtime";
import { DropdownFilterChip } from "@components/common/faro-table/faro-table-filter/dropdown-filter-chip";
import { useProjectMarkupsFilterLists } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup assignee */
export function ProjectMarkupsAssigneeFilter() {
  const $ = _c(4);
  const allFilters = useProjectMarkupsFilterLists();
  let t0;
  if ($[0] !== allFilters.Assignee) {
    t0 = allFilters.Assignee ?? {};
    $[0] = allFilters.Assignee;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <DropdownFilterChip label={ProjectMarkupsTableHeaders.assignee} filteredColumn={ProjectMarkupsTableHeaders.assignee} items={t0} shouldShowSearchBox={true} shouldShowCheckbox={true} tableType={TableType.projectMarkups} size="large" />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}